exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.region-select-container[data-v-3a3a31f4]{\n  color: #274048;\n  height: 32px;\n  line-height: 32px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.el-dropdown-link[data-v-3a3a31f4]{\n  font-size: 16px;\n}\n.el-dropdown-link i[data-v-3a3a31f4] {\n  color: #A1A1A1;\n}\n", ""]);

// exports
